import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  Self,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { QuillEditorComponent } from 'ngx-quill';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-quill-wrapper',
  templateUrl: './quill-wrapper.component.html',
  styleUrls: ['./quill-wrapper.component.sass'],
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: QuillWrapperComponent,
    },
  ],
})
export class QuillWrapperComponent extends MatFormFieldControl<any> implements ControlValueAccessor, OnInit, OnDestroy {
  static nextId = 0;

  @HostBinding() id = `quill-wrapper-${QuillWrapperComponent.nextId++}`;

  @HostBinding('attr.aria-describedby') describedBy = '';

  @Output() contentChangedEvent = new EventEmitter<string>();

  @Input()
  isEditor = true;

  @Input()
  content: string = '';

  @Input()
  placeholder: string = 'Insert text here...'; //cannot be undefined

  @ViewChild(QuillEditorComponent, { static: false }) editor?: QuillEditorComponent;

  stateChanges = new Subject<void>();

  focused = false;

  controlType = 'quill-wrapper';

  empty = true;

  control = new FormControl();

  private onChange: any = () => {};

  private onTouched: any = () => {};

  constructor(@Optional() @Self() public ngControl: NgControl, private elementRef: ElementRef<HTMLElement>) {
    super();
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    if (this.ngControl) {
      this.control.setValue(this.ngControl.value);
    }
  }

  ngOnDestroy(): void {
    this.stateChanges.complete();
  }

  writeValue(value: any): void {
    this.content = value;
    this.control.setValue(value);
    this.empty = !value;
    this.stateChanges.next();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isEditor = !isDisabled;
    this.stateChanges.next();
  }

  onContentChanged(event: any): void {
    this.onChange(event.html);
    this.contentChangedEvent.emit(this.content);
  }

  setDescribedByIds(ids: string[]): void {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(): void {
    this.onTouched();
  }
}
